

import React from "react";

export const ProposalMessage = (props) => {
    return (
        <div className="chat-message__content">
        
        </div>
    )
}